module.exports = __webpack_public_path__ + "static/media/HSS.8f069c65.jpg";